import { SelectInputItemProps } from 'types/SelectInputItemProps';

export const optionsRedirectType: SelectInputItemProps[] = [
	{ id: 'product', option: 'Produto' },
	{ id: 'url', option: 'URL' },
	{ id: 'app_screen', option: 'Tela dinâmica' },
	{ id: 'webview', option: 'Webview' },
	{ id: 'query', option: 'Query' },
	{ id: 'screen_app', option: 'Tela do app' },
	{ id: 'collections', option: 'Coleções' }
];

export const optionsType: SelectInputItemProps[] = [
	{ id: 'horizontal', option: 'Horizontal' },
	{ id: 'square', option: 'Quadrado' },
	{ id: 'vertical', option: 'Vertical Padrão' },
	{ id: 'vertical_taller', option: 'Vertical Estreito' }
];

export const optionsTypeBannerCarousel: SelectInputItemProps[] = [
	{ id: 'regular', option: 'Normal' },
	{ id: 'round', option: 'Redondo' },
	{ id: 'square', option: 'Quadrado' }
];

export const optionsTypeTitleRedirect: SelectInputItemProps[] = [
	{ id: 'none', option: 'Nenhum' },
	{ id: 'see-more', option: 'Ver mais' },
	{ id: 'with-image', option: 'Com imagem' }
];

export const optionsWeightFont: SelectInputItemProps[] = [
	{ id: 0, option: '100' },
	{ id: 1, option: '200' },
	{ id: 2, option: '300' },
	{ id: 3, option: '400' },
	{ id: 4, option: '500' },
	{ id: 5, option: '600' },
	{ id: 6, option: '700' },
	{ id: 7, option: '800' },
	{ id: 8, option: '900' }
];

export const optionsWeightFontText: SelectInputItemProps[] = [
	{ id: '100', option: '100' },
	{ id: '200', option: '200' },
	{ id: '300', option: '300' },
	{ id: '400', option: '400' },
	{ id: '500', option: '500' },
	{ id: '600', option: '600' },
	{ id: '700', option: '700' },
	{ id: '800', option: '800' },
	{ id: '900', option: '900' }
];

export const optionsTypeVerticalRedirectableLink: SelectInputItemProps[] = [
	{ id: 'card', option: 'Card' },
	{ id: 'tab', option: 'Tab' }
];

export const optionsTypeRedirectableLink: SelectInputItemProps[] = [
	{ id: 'tab', option: 'Tab' },
	{ id: 'card', option: 'Card' }
];

export const optionsCentralizeFocusText: SelectInputItemProps[] = [
	{ id: 'center', option: 'Centro' },
	{ id: 'left', option: 'Esquerda' },
	{ id: 'right', option: 'Direita' }
];

export const optionsSizeText: SelectInputItemProps[] = [
	{ id: 'small', option: 'Pequeno' },
	{ id: 'regular', option: 'Normal' },
	{ id: 'big', option: 'Grande' }
];
